import { api } from "../connection/api";

const baseEndpoint = "payment/ordersale";
const cieloEndpoint = "payment/cielo";

export async function sendOrderSale(params) {
  const data = await api.post(`${cieloEndpoint}/orderSaleRegistrationLink`, params);

  return data;
}

export async function removeOrderSale(transactionId) {
  return await api.delete(`${baseEndpoint}/remove/${transactionId}`);
}

export async function findByTransaction(transactionId) {
  return await api.get(`${baseEndpoint}/findByTransaction/${transactionId}`);
}

export async function findByAssociatedId(associatedId) {
  return await api.get(`${baseEndpoint}/findByAssociatedId/${associatedId}`);
}
